import { mapState } from 'vuex';
import ScheduledReportsPromotionFeatureBanner from '~/components/reports/ScheduledReportsPromotionFeatureBanner.vue';
import { pluralize } from '~/utils/string_utils';
import { extractPropsFromPromotion } from '~/utils/promotion_banner_props_utils';

const FILTERS = {
  singular: {
    projects: 'project / work order',
    users: 'team / member',
    statuses: 'status',
    status: 'status',
    clients: 'client',
    categories: 'category',
    members: 'team / member',
    job_sites: 'job site',
    tasks: 'to-do / job',
    actions: 'action',
    blame_users: 'changed by',
    payment_sources: 'payment type',
    time_off_policies: 'policy',
    time_off_transaction_types: 'type',
    created_by: 'changed by',
    work_break_policies: 'policy',
    work_break_statuses: 'status',
    time_types: 'time type',
    client_types: 'source',
    paid: 'paid',
    activity_level: 'activity level',
    time_off_and_holidays: 'time off / holiday',
    billable: 'billing type',
    tracked_time: 'tracked time',
  },
  plural: {
    projects: 'project / work orders',
    users: 'teams / members',
    statuses: 'statuses',
    status: 'statuses',
    clients: 'clients',
    categories: 'categories',
    members: 'teams / members',
    job_sites: 'job sites',
    tasks: 'to-dos / jobs',
    actions: 'actions',
    blame_users: 'changed by',
    payment_sources: 'payment types',
    time_off_policies: 'policies',
    time_off_transaction_types: 'types',
    created_by: 'changed by',
    work_break_policies: 'policies',
    work_break_statuses: 'statuses',
    time_types: 'time types',
    client_types: 'sources',
    paid: 'paid',
    activity_level: 'activity level',
    time_off_and_holidays: 'time offs / holidays',
    billable: 'billing type',
    tracked_time: 'tracked time',
  },
};

export default {
  components: {
    ScheduledReportsPromotionFeatureBanner,
  },
  data: () => ({
    showScheduledReport: false,
    showScheduledReportDialogPromotion: false,
    scheduleReportClickSource: null,
  }),
  computed: {
    ...mapState(['promotions']),
    ...mapState({
      scheduledReportsPromotionEnabled: 'scheduled_reports_promotion_enabled',
      scheduledReportsImprovementsFlagEnabled: 'scheduled_reports_improvements_flag_enabled',
    }),
    getDetailedFilterCounts() {
      if (!this.scheduledReportsPromotionEnabled) {
        return [];
      }

      return this.filterParser(
        Object.keys(this.detailedFiltersData).map((filter) => {
          const filterData = this.detailedFiltersData[filter];
          const filterSize = filterData.size || this.filterSize(this.reportQueryFilters[filter]);
          const check = filterData.check === '' ? false : filterData.check || filterSize > 0;
          const singular = filterData.singular || FILTERS.singular[filter];
          const plural = filterData.plural || FILTERS.plural[filter];

          return {
            filterSize,
            singular,
            plural,
            check,
          };
        }),
      );
    },
  },
  methods: {
    filterParser(filters) {
      const result = [];

      for (const filter of filters) {
        if (filter.check) {
          result.push(`${filter.filterSize} ${pluralize(filter.filterSize, filter.singular, filter.plural)}`);
        }
      }

      return result.filter((item) => item !== undefined);
    },
    filterSize(filter) {
      if (filter) {
        return filter.length;
      }

      return 0;
    },
    toggleDialog(value) {
      switch (value) {
        case 'scheduledReport':
          this.showScheduledReport = true;
          break;
        case 'scheduledReportBannerDialog':
          this.showScheduledReportDialogPromotion = true;
          break;
      }
    },
    doShowScheduleReportToast() {
      this.toggleDialog('scheduledReport');
      this.scheduleReportClickSource = 'export_toast';
    },
    closeScheduledReportDialog(value) {
      this.showScheduledReport = false;

      if (this.showScheduledReportAfterLoading) {
        this.showScheduledReportAfterLoading = false;
      }

      if (value === 'openFilters') {
        this.showFilters = true;
      }
    },
    closeScheduledReportsBannerDialog() {
      this.showScheduledReportDialogPromotion = false;
    },
    getPromotionProps() {
      return this.promotions
        .map((element) => extractPropsFromPromotion(element))
        .filter(
          (promotion) =>
            promotion.append && promotion.append.element !== null && promotion.feature === 'scheduled_reports',
        );
    },
  },
};
